import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';

import { PopupDialogAction, PopupDialogActionOptions } from '../models/popup-dialog-object';
import { SimpleErrorObject } from '../models/simple-error-object';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export class PcErrorHandlerService extends AbstractErrorHandlerService {

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(
			contentService,
			errorPopupService,
			tealiumAnalyticsService,
			errorHelperService
		);
	}

	public handleError(error): void {
		// Configuration Error
		if (error instanceof SimpleErrorObject && [ERROR_CODES.CURRENCY_LIST_ERROR, ERROR_CODES.BENCHMARK_LIST_ERROR].includes(error.code)) {

			// Tracking
			this.errorSeverity = ERROR_SEVERITY.ERROR;
			this.trackErrorMessage = 'configurationloaderror';
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);

			// Build error message
			this.errorMessage = this.contentService.get('GENERAL_CONFIG_ERROR', ErrorDCR.GENERAL_CONFIG_ERROR);
			const dialogErrorMessage = this.buildErrorMessage();
			dialogErrorMessage.actions = [
				PopupDialogAction.create({
					description: this.contentService.get('GENERAL_CONFIG_ERROR', ErrorDCR.ERROR_RETRY_MESSAGE),
					label: this.contentService.get('ERROR_RETRY_LABEL', ErrorDCR.ERROR_RETRY_LABEL),
					reload: true
				} as PopupDialogActionOptions)
			];

			console.error('There was an error: GENERAL_CONFIG_ERROR', error);
			this.errorPopupService.openResponseMessageDialog(dialogErrorMessage, true);

		} else {
			this.nextHandler.handleError(error);
		}
	}
}
